import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { Variables } from '../../base';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.div`
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
    line-height: 1;
`;

export const Latin1Error = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.warning};
    font-size: 13px;
    font-weight: 500;
    margin-top: 4px;
`;

export const Latin1ErrorIcon = styled(Icon)`
    fill: ${Variables.Colors.warning};
    margin-right: 4px;
`;
